import {
  Box,
  Checkbox,
  Dialog,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  SelectChangeEvent,
  Skeleton,
  Stack,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { Form, Formik, FormikProps } from '../../lib/formik/Formik';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  getInvestorReports,
  getReportSelectionList,
} from '../../redux-store/actions/investorReports';
import {
  downloadMultipleFiles,
  formatDate,
  isModuleAllowed,
  maskInfo,
  replaceLetterOWithW,
} from '../../utils/utilityFunctions';
import { ReportSectionContainer, ReportsRightLayout } from './index';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import FormMultiSelect from '../../lib/formik/FormMultiSelect';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { validationSchemaClientStatement } from '../../utils/schema';
import { Location } from 'history';
import { useHistory } from 'react-router';
import {
  getInvestorData,
  getRMDashBoardMetrics,
  getRmRedirectionLink,
} from '../../redux-store/actions/userManagement';
import {
  InvestorDetailEntity,
  ReportsListRes,
  ReportsPortfolioObj,
  RmDashboardType,
  RmRedirectionLinkType,
} from '../../redux-store/types/api-types';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "../../utils/dayjs";
import { reportData, reportDownload } from '../Reports/report-utils';
import { ColumnType } from '../DataTable';
import { DayJsDatePicker } from '../onboarding/newDatePicker';
import { RootStateType } from '../../redux-store/reducers';
import * as Yup from 'yup';
import { clientStatementDownload, createClientStatement, getClientStatementList, getClientStatementPDF, getFamilyMembers, getReportsInvestorList, renewedClientStatementPDF, updateClientStatementStatus } from '../../redux-store/actions/reports';
import MFSelectField from '../../lib/formik/SelectField';
import { CONTENT_TYPE, MPOWER_ACCOUNT_TYPE_MASTER, REPORTS_FILTER_TYPE_OPTIONS, requestReportsMaster } from '../../utils/constant';
import FormikSearchDropdown from '../../lib/formik/FormikSearchDropdown';
import { DialogCloseIcon, InfoIconOutlined, RefreshIcon, YellowWarning } from '../../assets/SvgIcons';
import ClientStatementTable from '../ClientStatementTable';
import { ClientStatementReportsList, CreateClientStatementResponseBody, FamilyMemberObj, GetClientStatementListResponseBody, GetFamilyMembersResponseBody, UpdateClientStatementStatusResponseBody } from '../../redux-store/types/onBoarding';
import { Order, PaginationObj, SortingObj } from '../investorOverview/types';
import MFCheckbox from '../../lib/formik/Checkbox';

const familyDropdownOptions = [
  {
    key: 'By Family',
    value: 1
  },
  {
    key: 'By Individual',
    value: 0
  }
]

interface Values {
  // selectedPortfolio: ReportsPortfolioObj | null;
  // selectedFamily: number;
  filterType: string;
  isHeldAway: boolean;
  filterTypeOptions: Array<{ key: string; value: string; }>;
  familyName: string;
  // startDate: any;
  endDate: any;
  reportSections: Array<string>;
  isExcFep: boolean;
  isHeldAwayCalc: boolean;
  rptConsolidatedLevel: boolean;
  familyMembersArray: Array<FamilyMemberObj>;
  selectedFamilyMember: FamilyMemberObj | null;
}

const INTERVAL_DURATION = 60 * 1000

const ClientStatement = ({
  location,
  handleSideSectionDisabled
}: {
  location: Location<{ investorId: string; investorName: string }>;
  handleSideSectionDisabled: (value: boolean) => void
}): JSX.Element => {
  const formikRef = useRef<FormikProps<Values>>(null);

  const theme = useTheme();
  const dispatch = useDispatch();
  const [reportSelection, setReportSelection] = useState<any>();
  const { enqueueSnackbar } = useSnackbar();
  const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
  const history = useHistory();
  const currentDate = dayjs();
  const [loading, setLoading] = useState<boolean>(false);
  const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
  const [dashBoardMetricsData, setDashBoardMetricsData] = useState<RmDashboardType | null>(null);
  const [investorData, setInvestorData] = useState<InvestorDetailEntity | null>(null);
  const [investorOptions, setInvestorOptions] = useState<any>([""]);
  const options = [{ invName: investorData?.I_InvName }, { invId: investorData?.OClientID }]
  const [isInitiating, setIsInitiating] = useState<boolean>(false);
  const [isDownloading, setIsDownloading] = useState<boolean>(false)
  const [investorListData, setInvestorListData] = useState<ReportsListRes>({} as ReportsListRes);
  const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false)
  const [isTableDataLoading, setTableDataLoading] = useState<boolean>(false)
  const [tableData, setTableData] = useState<Array<ClientStatementReportsList>>([])
  const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
    order: "desc",
    orderBy: "createdAt"
  })
  const [tablePaginationObj, setTablePaginationObj] = useState<PaginationObj>({
    currentPage: 0,
    rowsPerPage: 5,
    totalRows: 0
  })
  const [selectedJobIdForDownload, setSelectedJobIdForDownload] = useState<string | null>(null)
  const [isFamilyMembersDataLoading, setFamilyMembersDataLoading] = useState<boolean>(false)
  const [fetchedFamilyMembers, setFetchedFamilyMembers] = useState<Array<FamilyMemberObj>>([])

  const { isNavbarInfoLoading, businessDate } = useSelector((state: RootStateType) => state.navbarInfo);
  const { permissions = [] } = useSelector((store: RootStateType) => store.auth);

  const tablePaginationObjRef = useRef(tablePaginationObj)
  const tableSortingObjRef = useRef(tableSortingObj)
  const tableDataRef = useRef(tableData)

  const todayDate = new Date();
  const formattedBusinessDate = businessDate?.length ? dayjs(businessDate, "DD/MM/YYYY").subtract(1, 'day').format("YYYY-MM-DD") : dayjs(todayDate).format("YYYY-MM-DD");
  // const formattedBusinessDate = '2025-05-02';
  // const formattedBusinessDate = dayjs(todayDate).subtract(1, 'day').format("YYYY-MM-DD");

  // const currentYear = new Date().getFullYear();
  // const firstDayOfYear = new Date(currentYear, 0, 1);
  // const formattedFirstDayOfYear = dayjs(firstDayOfYear).format('YYYY-MM-DD');

  const { iwappRmId = "", investorClientId = "", familyId = "", familyName = "", panNo = "", isFamilyHead = "" } = useSelector((state: RootStateType) => state.id);
  const { selectedPortfolioObj } = useSelector((state: RootStateType) => state.selectedPortfiolio)

  const isCombinedReportAllowed = isModuleAllowed({ value: "combinedCliReport", compareArr: permissions, objKey: "permissonCode" })

  const options2 = [
    {
      header: 'Investor Name',
      value: (row: InvestorDetailEntity) => row.I_InvName,
    },]

  const fetchInvestorList = async () => {
    try {
      setLoading(true);
      const payload = {
        rmId: `${iwappRmId}`,
        clientCode: `${investorClientId}`,
      }
      const response = await (dispatch(getReportsInvestorList(payload)) as unknown as Promise<ReportsListRes>);
      setInvestorListData(response);
      if (!response?.isSuccess) {
        setNoInvestorDialogVisible(true)
      }
    } catch (e) {
      console.log((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const handleNoInvestorDialogClose = () => {
    setNoInvestorDialogVisible(false)
  }

  // useEffect(() => {
  //   let isComponentAlive = true;
  //   (async function () {
  //     try {
  //       fetchInvestorList();
  //       // const reportSelectionList = (await dispatch(getReportSelectionList())) as unknown as any[];
  //       // const transformedRes = reportSelectionList.map((obj: any) => {
  //       //   return {
  //       //     label: obj.Name,
  //       //     value: obj.ID,
  //       //   };
  //       // });
  //       if (!isComponentAlive) return;
  //       // setReportSelection(transformedRes);
  //       setReportSelection([])
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  //   return () => {
  //     isComponentAlive = false;
  //   };
  // }, []);

  // useEffect(() => {
  //   let isComponentActive = true;
  //   setInvestorOptions(investorData);
  //   (async function () {
  //     try {
  //       // setLoading(true);
  //       const response = (await dispatch(getRMDashBoardMetrics())) as RmDashboardType;
  //       if (!isComponentActive) {
  //         return;
  //       }
  //       setInvestorData(response);
  //       // setInvestorOptions(response.investorDetail)
  //       // setLoading(false);
  //     } catch (e) {
  //       // setLoading(false);
  //       console.log((e as Error).message);
  //     }
  //   })();
  //   return () => {
  //     isComponentActive = false;
  //   };

  // }, []);
  // console.log("inv detail", setInvestorData)
  // useEffect(() => {

  //   if (!investorId) {
  //     let isComponentActive = true;
  //     setDashBoardMetricsData(null);
  //     (async function () {
  //       try {
  //         const response = {} as RmDashboardType;

  //         if (!isComponentActive) {
  //           return;
  //         }
  //         setDashBoardMetricsData(response);
  //         setInvestorOptions(investorData?.I_InvName)
  //       } catch (e) {
  //         console.log((e as Error).message);
  //       }
  //     })();
  //     return () => {
  //       isComponentActive = false;
  //     };
  //   }
  // }, [])

  const fetchTableData = async ({
    currentPage,
    rowsPerPage,
    sort,
    order,
    updatePendingReports
  }: {
    currentPage: number;
    rowsPerPage: number;
    sort: string;
    order: Order;
    updatePendingReports: boolean;
  }) => {
    try {
      setTableDataLoading(true)

      const payload = {
        rmId: `${iwappRmId}`,
        sort,
        order,
        currentPage,
        rowsPerPage,
        clientCode: `${investorClientId ?? ""}`,
        updatePendingReports
      }

      const {
        count = 0,
        reports = []
      } = await (dispatch(updateClientStatementStatus(payload)) as unknown as Promise<UpdateClientStatementStatusResponseBody>)

      setTableData(reports)
      setTableSortingObj({
        order,
        orderBy: sort
      })
      setTablePaginationObj({
        currentPage: currentPage - 1,
        rowsPerPage,
        totalRows: count
      })
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setTableDataLoading(false)
    }
  }


  useEffect(() => {
    tablePaginationObjRef.current = tablePaginationObj;
    tableSortingObjRef.current = tableSortingObj;
    tableDataRef.current = tableData
  }, [tablePaginationObj, tableSortingObj, tableData]);

  useEffect(() => {
    if (!iwappRmId) return

    const fetchData = async () => {
      await fetchTableData({
        currentPage: tablePaginationObj.currentPage + 1,
        rowsPerPage: tablePaginationObj.rowsPerPage,
        sort: tableSortingObj.orderBy,
        order: tableSortingObj.order,
        updatePendingReports: true
      })
    }

    fetchData()

    const intervalId = setInterval(async () => {
      if ((tableDataRef.current ?? []).some(obj => `${obj?.status ?? ""}`.toLowerCase() === "pending")) {

        await fetchTableData({
          currentPage: tablePaginationObjRef.current.currentPage + 1,
          rowsPerPage: tablePaginationObjRef.current.rowsPerPage,
          sort: tableSortingObjRef.current.orderBy,
          order: tableSortingObjRef.current.order,
          updatePendingReports: true,
        });

      }
    }, INTERVAL_DURATION);

    return () => clearInterval(intervalId);

  }, [])

  useEffect(() => {
    if (`${isFamilyHead ?? ""}`.toLowerCase() !== "y" || !familyId) return;

    const fetchFamilyMembers = async () => {
      try {
        setFamilyMembersDataLoading(true);

        const response = await (dispatch(
          getFamilyMembers(familyId)
        ) as unknown as Promise<GetFamilyMembersResponseBody>);

        if (response) {
          setFetchedFamilyMembers(response?.familyMembers ?? [])
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        setFamilyMembersDataLoading(false);
      }
    };

    fetchFamilyMembers();

  }, [familyId, isFamilyHead]);

  const initialValues: Values = {
    // selectedFamily: 0,
    // selectedPortfolio: null,
    filterType: "PORTFOLIO",
    isHeldAway: false,
    filterTypeOptions: `${isFamilyHead ?? ""}`.toLowerCase() === "y" ? REPORTS_FILTER_TYPE_OPTIONS : REPORTS_FILTER_TYPE_OPTIONS.filter(item => `${item?.key}`.toLowerCase() !== "family"),
    familyName: "",
    // startDate: formattedFirstDayOfYear,
    endDate: formattedBusinessDate,
    reportSections: [],
    isExcFep: false,
    isHeldAwayCalc: false,
    rptConsolidatedLevel: false,
    familyMembersArray: fetchedFamilyMembers,
    selectedFamilyMember: null
  };

  const validationSchemaClientStatement = Yup.object().shape({
    // selectedPortfolio: Yup
    //   .object()
    //   .nullable()
    //   .test(
    //     "portfolio-required",
    //     "Please select a portfolio",
    //     function (value) { return !!value }
    //   ),
    // selectedFamily: Yup.string().required('Required'),
    // date: Yup.
    //   date()
    //   .required('Date is required')
    //   .typeError('Date is required')
    //   .min(dayjs("1950-01-01").format("YYYY-MM-DD"), "Date should not be less than 01/01/1950")
    //   .max(formattedBusinessDate, "Date should not be greater than system's date"),
    filterType: Yup
      .string()
      .required('Please select a Filter type'),
    reportSections: Yup
      .array()
      .of(
        Yup
          .string()
      )
      .min(1, 'Please select a report section'),
    // startDate: Yup.
    //   date()
    //   .typeError('Start Date should be valid date')
    //   .min(dayjs(formattedFirstDayOfYear).format("YYYY-MM-DD"), `Start Date should not be less than ${dayjs(formattedFirstDayOfYear).format("DD/MM/YYYY")}`)
    //   .test('fromDateTest', 'Start Date cannot be greater than As on Date', function (value) {
    //     const { endDate } = this.parent;
    //     return !endDate || !value || value <= endDate;
    //   }),
    endDate: Yup
      .date()
      .required('As on Date is required')
      .typeError('As on Date is required')
      .max(formattedBusinessDate, "As on Date should not be greater than system's date"),
    // .test('toDateTest', 'As on Date cannot be less than Start Date ', function (value) {
    //   const { startDate } = this.parent;
    //   return !startDate || !value || value >= startDate;
    // }),
  })

  // const onSubmit = async (values: any) => {
  //   try {
  //     const { reportOptions, date, redeemedSchemesFlg, transactionHistoryFlg } = values;
  //     const formattedDate = `${new Date(date).getDate().toString().padStart(2, '0')}/${(new Date(date)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(date).getFullYear()}`;
  //     console.log("formattedDate", formattedDate)
  //     const allIdValue = reportSelection.find(
  //       (option: { label: string; value: string }) => option.label.toLowerCase() === 'all'
  //     ).value;
  //     if (investorId) {
  //       setLoading(true)
  //       const res = await dispatch(
  //         getInvestorReports({
  //           // clientId: [replaceLetterOWithW(investorId) || ''],
  //           clientId: [investorId || ''],
  //           toDate: formattedDate,
  //           reportName: 'ClientStatement',
  //           reportConfig: {
  //             redeemedSchemesFlg: redeemedSchemesFlg.toString(),
  //             transactionHistoryFlg: transactionHistoryFlg.toString(),
  //             reportOptions:
  //               reportOptions.indexOf(allIdValue) !== -1 ? [allIdValue] : reportOptions,
  //           },
  //         })
  //       );
  //       setLoading(false)
  //       downloadMultipleFiles(res);
  //       enqueueSnackbar('File(s) downloaded successfully.', {
  //         variant: 'success',
  //         autoHideDuration: 3000,
  //       });
  //     }
  //     setDates(dayjs(currentDate).format("YYYY-MM-DD"));
  //   } catch (e) {
  //     console.error((e as Error).message);
  //   }
  // };

  const handleRefresh = async () => {
    await fetchTableData({
      currentPage: 1,
      rowsPerPage: tablePaginationObj.rowsPerPage,
      sort: tableSortingObj.orderBy,
      order: tableSortingObj.order,
      updatePendingReports: true
    })
  }

  const handleSubmit = async ({
    // selectedPortfolio,
    // selectedFamily,
    filterType,
    isHeldAway,
    endDate,
    reportSections,
    isExcFep,
    isHeldAwayCalc,
    rptConsolidatedLevel,
    selectedFamilyMember
  }: Values) => {
    try {
      setIsInitiating(true)
      handleSideSectionDisabled(true)
      // const investor = investorListData?.result?.find((i: ReportsListObj) => i.clientCode === selectedInvestor);
      // const payload = {
      //   rmID: `${iwappRmId}`,
      //   family: Boolean(selectedFamily),
      //   // clientCode: investorClientId,
      //   customer_name: investorClientId,
      //   portfolio: selectedPortfolio?.portfolioId ?? "",
      //   // from: dayjs(date, "YYYY-MM-DD").subtract(1, "year").format("DD/MM/YYYY"),
      //   // end: dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      //   report_date: dayjs(date, "YYYY-MM-DD").format("YYYY-MM-DD"),
      //   requested_reports: (reportSections ?? []).map(Number)
      // }

      // const renewedPayload = {
      //   clientCode: investorClientId ?? '',
      // }

      const idMap: { [key: string]: string } = {
        FAMILY: `${familyId ?? ""}`,
        CUSTOMER: selectedFamilyMember ? (selectedFamilyMember?.panNo ?? "") : `${panNo ?? ""}`,
        PORTFOLIO: selectedFamilyMember
          ? (selectedFamilyMember?.portfolioList?.[0]?.portfolioId ?? "")
          : `${selectedPortfolioObj?.portfolioId ?? ""}`
      }

      const payload = {
        clientCode: selectedFamilyMember ? `${selectedFamilyMember?.clientCode ?? ""}` : `${investorClientId ?? ""}`,
        rmId: `${iwappRmId}`,
        // startDate: `${startDate ?? ""}`,
        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
        accountType: selectedFamilyMember
          ? (selectedFamilyMember?.accountType ?? "")
          : `${selectedPortfolioObj?.portfolioAccountType ?? ""}`,
        requested_reports: (reportSections ?? []).map(Number),
        consolidatedLevel: filterType === "CUSTOMER" ? "PAN" : filterType,
        custFilterValue: idMap[filterType ?? ""] ?? "",
        heldAway: isHeldAway ? 'Y' : 'N',
        isExcFep: isExcFep ? 'Y' : 'N',
        isHeldAwayCalc: isHeldAwayCalc ? 'Y' : 'N',
        rptConsolidatedLevel: rptConsolidatedLevel ? "Y" : "N"
      }

      // const response = await (dispatch(getClientStatementPDF(payload)) as unknown as Promise<any>)
      // const response = await (dispatch(renewedClientStatementPDF(renewedPayload)) as unknown as Promise<any>)

      const response = await (dispatch(createClientStatement(payload)) as unknown as Promise<CreateClientStatementResponseBody>)

      // if (response.type === CONTENT_TYPE.PDF) {
      //   enqueueSnackbar('File downloaded successfully.', {
      //     variant: 'success',
      //     autoHideDuration: 2000,
      //   });
      //   reportDownload(response as unknown as Blob, 'ClientStatement.pdf');
      // } else {
      //   enqueueSnackbar('File download failed!.', {
      //     variant: 'error',
      //     autoHideDuration: 2000,
      //   });
      // }

      if (response?.isSuccess) {
        enqueueSnackbar(`${response?.message ?? ""}`, {
          variant: 'success',
          autoHideDuration: 5000,
        });

        await handleRefresh()

        return
      }
      if (!response?.isSuccess) {
        enqueueSnackbar(`${response?.message ?? ""}`, {
          variant: 'error',
          autoHideDuration: 5000,
        });

        return
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setIsInitiating(false)
      handleSideSectionDisabled(false)
    }
  }

  // const handleInvestorChange = (selectedObj: Record<string, any>) => {
  //   if (!formikRef.current) return

  //   const { values, setValues } = formikRef.current ?? {}

  //   if (!selectedObj) {
  //     setValues({
  //       ...values,
  //       selectedPortfolio: null
  //     })

  //     return
  //   }

  //   setValues({
  //     ...values,
  //     selectedPortfolio: selectedObj as ReportsPortfolioObj,
  //   })
  // }

  const handleFamilyMemberChange = (selectedObj: Record<string, any>) => {
    if (!formikRef.current) return;

    const { values, setValues } = formikRef.current;

    if (!selectedObj) {
      setValues({
        ...values,
        filterType: "PORTFOLIO",
        isHeldAway: false,
        filterTypeOptions:
          `${isFamilyHead ?? ""}`.toLowerCase() === "y"
            ? REPORTS_FILTER_TYPE_OPTIONS
            : REPORTS_FILTER_TYPE_OPTIONS.filter((item) => `${item?.key}`.toLowerCase() !== "family"),
        familyName: "",
        endDate: formattedBusinessDate,
        reportSections: (values?.reportSections ?? []).filter((key) => key !== "4"),
        isExcFep: false,
        isHeldAwayCalc: false,
        rptConsolidatedLevel: false,
        selectedFamilyMember: null
      });

      return;
    }

    setValues({
      ...values,
      filterType: "PORTFOLIO",
      isHeldAway: false,
      filterTypeOptions:
        `${selectedObj?.isHeadOfFamily ?? ""}`.toLowerCase() === "y"
          ? REPORTS_FILTER_TYPE_OPTIONS
          : REPORTS_FILTER_TYPE_OPTIONS.filter((item) => `${item?.key}`.toLowerCase() !== "family"),
      familyName: "",
      endDate: formattedBusinessDate,
      reportSections: (values?.reportSections ?? []).filter((key) => key !== "4"),
      isExcFep: false,
      isHeldAwayCalc: false,
      rptConsolidatedLevel: false,
      selectedFamilyMember: selectedObj as FamilyMemberObj,
    });
  };


  const handleTableSort = async (orderBy: string, order: Order) => {
    await fetchTableData({
      currentPage: 1,
      rowsPerPage: tablePaginationObj.rowsPerPage,
      sort: orderBy,
      order,
      updatePendingReports: false
    })
  }

  const handleTableRowsPerPageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    await fetchTableData({
      currentPage: 1,
      rowsPerPage: Number(event.target.value),
      sort: tableSortingObj.orderBy,
      order: tableSortingObj.order,
      updatePendingReports: false
    })
  }

  const handleTablePageChange = async (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    await fetchTableData({
      currentPage: page + 1,
      rowsPerPage: tablePaginationObj.rowsPerPage,
      sort: tableSortingObj.orderBy,
      order: tableSortingObj.order,
      updatePendingReports: false
    })
  }
  const handleReportDownload = async (jobId: string, clientName: string) => {
    try {
      setIsDownloading(true)
      handleSideSectionDisabled(true)

      setSelectedJobIdForDownload(jobId)

      const payload = { jobId }

      const response = await (dispatch(clientStatementDownload(payload)) as unknown as Promise<any>)

      if (response.type === CONTENT_TYPE.PDF) {
        enqueueSnackbar('File downloaded successfully.', {
          variant: 'success',
          autoHideDuration: 5000,
        });
        reportDownload(response as unknown as Blob, `${clientName ?? ""}-ClientStatement.pdf`);
      } else {
        enqueueSnackbar('File download failed!.', {
          variant: 'error',
          autoHideDuration: 5000,
        });
      }

    } catch (e) {
      console.log("Error:", e)
    } finally {
      setIsDownloading(false)
      handleSideSectionDisabled(false)
      setSelectedJobIdForDownload(null)
    }
  }

  const handleFilterTypeChange = ({ target: { value } }: SelectChangeEvent<unknown>) => {
    if (!formikRef?.current) {
      return
    }

    const { values: formikValues, setValues } = formikRef.current

    const modifiedReportSections = [...(formikValues?.reportSections ?? [])]

    if (
      ["customer", "family"].includes(`${value ?? ""}`.toLowerCase()) &&
      !modifiedReportSections.includes("4")
    ) {
      modifiedReportSections.push("4")
    }

    setValues({
      ...formikValues,
      filterType: `${value ?? ""}`,
      isHeldAway: false,
      isHeldAwayCalc: false,
      ...((`${value ?? ""}`.toLowerCase() === "family") ? {
        familyName: formikValues?.selectedFamilyMember
          ? (formikValues?.selectedFamilyMember?.familyName ?? "")
          : (familyName ?? "")
      } : {
        familyName: ""
      }),
      reportSections: (modifiedReportSections)
        .filter(key => {
          if (!["customer", "family"].includes(`${value ?? ""}`.toLowerCase())) {
            return key !== "4"
          }
          return true
        }),
      rptConsolidatedLevel: false
    })
  }

  return (
    <>
      <ReportsRightLayout>
        <Typography
          variant='h2'
          sx={{
            color: 'text.primary',
            lineHeight: '25px',
            letterSpacing: '0.01px',
            mb: '40px',

          }}
        >
          Client Statement
        </Typography>
        <Formik
          innerRef={formikRef}
          validationSchema={validationSchemaClientStatement}
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setValues }) => {
            const requestedReportsObj = requestReportsMaster(`${values?.filterType ?? ""}`.toLowerCase())

            return (
              <Form>
                {/* <ReportSectionContainer>
                  <Stack>
                    
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
  
                      <DatePicker
                        label="You are requesting client statement"
                        value={dayjs(dates)}
                        maxDate={dayjs(currentDate)}
  
                        onChange={(date: any) => {
                          setDates(date.format("YYYY-MM-DD"))
                          setFieldValue('date', date)
                        }
                        }
                      />
  
                    </LocalizationProvider>
                  </Stack>
                </ReportSectionContainer> */}
                {/* <ReportSectionContainer>
                  <Stack>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '22px',
                        letterSpacing: '0.01em',
                      }}>
                      Report Selection
                    </Typography>
                    <FormMultiSelect
                      name={'reportOptions'}
                      onChange={(e) => {
                        const value = e.target.value as Array<number>;
                        const allIdValue: number = reportSelection.find(
                          (option: { label: string; value: string }) =>
                            option.label.toLowerCase() === 'all'
                        ).value;
                        if (
                          value.length < values.reportOptions.length &&
                          value.indexOf(allIdValue) !== -1
                        ) {
                          value.splice(value.indexOf(allIdValue), 1);
                          setFieldValue('reportOptions', value);
                        } else if (value.indexOf(allIdValue) !== -1) {
                          setFieldValue(
                            'reportOptions',
                            reportSelection.map((each: any) => each.value)
                          );
                        } else if (
                          value.length === reportSelection.length - 1 &&
                          values.reportOptions.indexOf(allIdValue) === -1
                        ) {
                          setFieldValue('reportOptions', [...value, allIdValue]);
                        } else if (
                          value.indexOf(allIdValue) === -1 &&
                          values.reportOptions.indexOf(allIdValue) !== -1
                        ) {
                          setFieldValue('reportOptions', []);
                        } else {
                          setFieldValue('reportOptions', value);
                        }
                      }}
                      options={reportSelection}
                      placeholder={'Select here'}
                    />
  
                    <Stack>
                      <FormControl component="fieldset">
                        <FormGroup aria-label="position">
                          <FormControlLabel
                            value={Boolean(values.redeemedSchemesFlg)}
                            checked={Boolean(values.redeemedSchemesFlg)}
                            onChange={(_, checked) => {
                              setFieldValue('redeemedSchemesFlg', Number(checked));
                            }}
                            control={<Checkbox />}
                            label="Redeemed Schemes"
                            labelPlacement="end"
                          />
                          <FormControlLabel
                            value={Boolean(values.transactionHistoryFlg)}
                            checked={Boolean(values.transactionHistoryFlg)}
                            onChange={(_, checked) => {
                              setFieldValue('transactionHistoryFlg', Number(checked));
                            }}
                            control={<Checkbox />}
                            label="Transaction History (since inception)"
                            labelPlacement="end"
                          />
                        </FormGroup>
                      </FormControl>
                    </Stack>
                  </Stack>
                </ReportSectionContainer> */}
                {/* <Stack justifyContent="center" alignItems="center" sx={{ m: 2 }}>
                  <MFSubmitButton label="Download" loadingEnable={loading} />
                </Stack> */}

                <Grid container rowSpacing={2}>
                  <Grid item container columnSpacing={3} rowSpacing={2}>
                    {/* <Grid item xs={12} lg={6}>
                      {isNavbarInfoLoading && <Skeleton
                        animation={'wave'}
                        height={90}
  
                      />}
                      {!isNavbarInfoLoading && <FormMultiSelect
                        name={'reportOptions'}
                        placeholder='Select Report'
                        onChange={(e) => {
                          const value = e.target.value as Array<number>;
                          const allIdValue: number = reportSelection?.find(
                            (option: { label: string; value: string }) =>
                              option.label.toLowerCase() === 'all'
                          )?.value;
                          if (
                            value.length < values.reportOptions.length &&
                            value.indexOf(allIdValue) !== -1
                          ) {
                            value.splice(value.indexOf(allIdValue), 1);
                            setFieldValue('reportOptions', value);
                          } else if (value.indexOf(allIdValue) !== -1) {
                            setFieldValue(
                              'reportOptions',
                              reportSelection?.map((each: any) => each.value)
                            );
                          } else if (
                            value.length === reportSelection?.length - 1 &&
                            values.reportOptions.indexOf(allIdValue) === -1
                          ) {
                            setFieldValue('reportOptions', [...value, allIdValue]);
                          } else if (
                            value.indexOf(allIdValue) === -1 &&
                            values.reportOptions.indexOf(allIdValue) !== -1
                          ) {
                            setFieldValue('reportOptions', []);
                          } else {
                            setFieldValue('reportOptions', value);
                          }
                        }}
                        options={[{ label: "Executive Summary", value: 1 }, { label: "Asset-class wise Holding Report", value: 2 }]}
                      />}
                    </Grid> */}
                    {/* <Grid item xs={12} lg={6}>
                      {(isNavbarInfoLoading) && <Skeleton
                        animation={'wave'}
                        height={90}
  
                      />}
                      {(!isNavbarInfoLoading) && (
                        <MFSelectField
                          name={'selectedFamily'}
                          label="Family"
                          placeholder='Select Family'
                          items={familyDropdownOptions}
                          value={values.selectedFamily}
                          onChange={(e) => {
                            setFieldValue("selectedFamily", e.target.value);
                          }}
                          sx={(theme: Theme) => ({
                            '& .Mui-disabled': {
                              cursor: !(loading || isDownloading) ? 'pointer' : 'not-allowed !important',
                              pointerEvents: 'all',
                            },
                            '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                              borderColor: `${theme.palette.text.secondary}4D`,
                            },
                            '&.Mui-disabled .MuiSelect-select': {
                              color: "green",
                            },
                            '&.Mui-disabled svg': {
                              color: `${theme.palette.text.secondary}4D`,
                            },
                          })}
                          disabled={isDownloading}
                        />)}
                    </Grid> */}
                    <Grid item xs={12} lg={6}>
                      {(
                        loading ||
                        isNavbarInfoLoading ||
                        isFamilyMembersDataLoading
                      ) && <Skeleton
                          animation={'wave'}
                          height={90}
                        />}
                      {(
                        !loading &&
                        !isNavbarInfoLoading &&
                        !isFamilyMembersDataLoading
                      ) && (
                          <MFTextField
                            label='Client Code'
                            placeholder={'Client Code'}
                            name={'clientCode'}
                            value={investorClientId}
                            disabled={true}
                          // sx={{
                          //   width: { md: '12rem', lg: '20rem' },
                          //   '& .MuiInputBase-root': {
                          //     fontSize: { md: 12, lg: 14 },
                          //     border: '0 !important',
                          //     boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
                          //     ':hover': {
                          //       border: 0,
                          //       boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
                          //     },
                          //   },
                          // }}
                          />
                        )}
                    </Grid>

                    {(`${isFamilyHead ?? ""}`.toLowerCase() === "y") && (
                      <Grid item xs={12} lg={6}>
                        {(
                          loading ||
                          isFamilyMembersDataLoading ||
                          isNavbarInfoLoading
                        ) && (
                            <Skeleton
                              animation={'wave'}
                              height={90}
                            />
                          )}
                        {(
                          !loading &&
                          !isFamilyMembersDataLoading &&
                          !isNavbarInfoLoading
                        ) && (
                            <FormikSearchDropdown
                              name="selectedFamilyMember"
                              label="Family Members"
                              options={(values?.familyMembersArray ?? [])?.map((obj: FamilyMemberObj) => ({
                                ...obj,
                                label: `${maskInfo(obj.name)} (${obj?.clientCode ?? ""}) ${obj?.investorType ? "(" + obj?.investorType + ")" : ""} ${`${obj?.isHeadOfFamily ?? ""}`.toLowerCase() === "y" ? "(Head Of Family)" : ""} ${MPOWER_ACCOUNT_TYPE_MASTER[obj?.accountType ?? ""] ? " - " + MPOWER_ACCOUNT_TYPE_MASTER[obj.accountType] : ""}`,
                                value: obj.clientCode,
                              }))}
                              onChange={handleFamilyMemberChange}
                              disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                            />
                          )}
                      </Grid>
                    )}
                    {/* Filter Type Dropdown start */}
                    <Grid item xs={12} lg={6}>
                      {(
                        loading ||
                        isNavbarInfoLoading ||
                        isFamilyMembersDataLoading
                      ) && <Skeleton
                          animation={'wave'}
                          height={90}

                        />}
                      {(
                        !loading &&
                        !isNavbarInfoLoading &&
                        !isFamilyMembersDataLoading
                      ) && (
                          <MFSelectField
                            name='filterType'
                            label="Filter Type *"
                            items={values?.filterTypeOptions ?? []}
                            disabled={
                              loading ||
                              isDownloading ||
                              isNavbarInfoLoading ||
                              isInitiating
                            }
                            onChange={handleFilterTypeChange}
                          />
                        )}
                    </Grid>
                    {/* Filter Type Dropdown end */}

                    {/* Family Name start */}
                    {(`${values?.filterType ?? ""}`.toLowerCase() === "family") && (
                      <Grid item xs={12} lg={6}>
                        <MFTextField
                          name="familyName"
                          label="Family Name"
                          placeholder=""
                          disabled={true}
                          value={values?.familyName ?? ""}
                        />
                      </Grid>
                    )}
                    {/* Family Name end */}
                    <Grid item xs={12} lg={6}>
                      {(
                        loading ||
                        isNavbarInfoLoading ||
                        isFamilyMembersDataLoading
                      ) && <Skeleton
                          animation={'wave'}
                          height={90}

                        />}
                      {(
                        !loading &&
                        !isNavbarInfoLoading &&
                        !isFamilyMembersDataLoading
                      ) && (
                          <>
                            <TextDatePicker
                              name="endDate"
                              label="As on date *"
                              placeholder=""
                              maxDate={new Date(formattedBusinessDate)}
                              disabled={
                                loading ||
                                isDownloading ||
                                isNavbarInfoLoading ||
                                isInitiating
                              }
                            />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: "10px",
                                marginTop: "-10px"
                              }}>
                              <InfoIconOutlined />
                              <Typography
                                variant='subtitle_600'
                                sx={(theme: Theme) => ({
                                  color: theme.palette.grey[900]
                                })}
                              >
                                Reports are generated Since Inception.
                              </Typography>
                            </Box>
                          </>
                        )}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {(
                        loading ||
                        isNavbarInfoLoading ||
                        isFamilyMembersDataLoading
                      ) && <Skeleton
                          animation={'wave'}
                          height={90}
                        />}
                      {(
                        !loading &&
                        !isNavbarInfoLoading &&
                        !isFamilyMembersDataLoading
                      ) && (
                          <FormMultiSelect
                            name="reportSections"
                            label='Select Report Sections *'
                            options={Object.keys(requestedReportsObj)
                              .filter(key => {
                                if (!["customer", "family"].includes(`${values?.filterType ?? ""}`.toLowerCase())) {
                                  return key !== "4"
                                }
                                return true
                              })
                              .map(key => ({
                                label: requestedReportsObj[key],
                                value: key
                              }))}
                            sx={{
                              "&.MuiOutlinedInput-root": {
                                "& fieldset>legend": {
                                  fontSize: { xs: "0.6em", md: "0.7em", lg: "0.8em" }
                                }
                              }
                            }}
                            disabled={
                              loading ||
                              isDownloading ||
                              isNavbarInfoLoading ||
                              isInitiating
                            }
                          />
                        )}
                    </Grid>
                    {/* <Grid item xs={12}>
                      {(loading || isNavbarInfoLoading) && <Skeleton
                        animation={'wave'}
                        height={90}
  
                      />}
                      {(!loading && !isNavbarInfoLoading) && (
                        <FormikSearchDropdown
                          name='selectedPortfolio'
                          label='Select Portfolio *'
                          options={(investorListData?.result?.[0]?.portfolioList ?? [])?.map((obj: ReportsPortfolioObj) => ({
                            ...obj,
                            label: `${obj?.portfolioName ?? ""} (${obj?.portfolioId ?? ""})`,
                            value: obj?.portfolioId ?? ""
                          }))}
                          onChange={handleInvestorChange}
                          disabled={loading || isDownloading || isNavbarInfoLoading}
                        />
                      )}
                    </Grid> */}
                    {/* <Grid item xs={12} lg={6}>
                      {(loading || isNavbarInfoLoading) && <Skeleton
                        animation={'wave'}
                        height={90}
  
                      />}
                      {(!loading && !isNavbarInfoLoading) && (
                        <DayJsDatePicker
                          id=""
                          name='startDate'
                          label="Start date"
                          // minDate={new Date(formattedFirstDayOfYear)}
                          disabled={
                            loading ||
                            isDownloading ||
                            isNavbarInfoLoading ||
                            isInitiating
                          }
                          currentDate={formattedFirstDayOfYear}
                        />
                      )}
                    </Grid> */}

                    {/* Consolidated Client and Family Report */}
                    {(isCombinedReportAllowed && ["family", "customer"].includes(`${values?.filterType ?? ""}`.toLowerCase())) && (
                      <Grid
                        item
                        xs={12}
                        lg={6}
                      >
                        <Box
                          sx={{
                            paddingTop: { xs: "0px", lg: "25px" },
                            paddingBottom: "5px"
                          }}
                        >
                          <MFCheckbox
                            name="rptConsolidatedLevel"
                            label={`${values?.filterType ?? ""}`.toLowerCase() === "family" ? "Combined Family Report" : "Combined Client Report"}
                            sx={(theme: Theme) => ({
                              display: 'flex',
                              alignItems: 'flex-start',
                              color: `${theme.palette.text.primary}`,
                              "& :disabled": {
                                color: `${theme.palette.text.secondary}`,
                              }
                            })}
                            disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            columnGap: "10px",
                          }}>
                          <InfoIconOutlined />
                          <Typography
                            variant='subtitle_600'
                            sx={(theme: Theme) => ({
                              color: theme.palette.grey[500]
                            })}
                          >
                            Combined report include both Distributary and Advisory portfolios.
                          </Typography>
                        </Box>
                      </Grid>
                    )}

                    {/* Exclude Fully Exited Positions Checkbox start */}
                    <Grid
                      item
                      container
                      xs={12}
                      lg={6}
                      sx={{ alignItems: "center" }}
                    >
                      <Grid item
                        sx={{
                          ...(["customer"].includes(`${values?.filterType ?? ""}`.toLowerCase()) ? {
                            paddingBottom: { xs: "0px", lg: "25px" }
                          } : {})
                        }}
                      >
                        <MFCheckbox
                          name="isExcFep"
                          label="Exclude Fully Exited Positions"
                          sx={(theme: Theme) => ({
                            display: 'flex',
                            alignItems: 'flex-start',
                            color: `${theme.palette.text.primary}`,
                            "& :disabled": {
                              color: `${theme.palette.text.secondary}`,
                            }
                          })}
                          disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                        />
                      </Grid>
                    </Grid>
                    {/* Exclude Fully Exited Positions Checkbox end */}

                    {/* HeldAway Checkbox start */}
                    {(`${values?.filterType ?? ""}`.toLowerCase() !== "portfolio") && (
                      <Grid
                        item
                        container
                        xs={12}
                        lg={6}
                        sx={{ alignItems: "center" }}
                      >
                        <Grid item sx={{
                          ...(
                            !isCombinedReportAllowed &&
                            (["customer"].includes(`${values?.filterType ?? ""}`.toLowerCase()))
                          ) ? { paddingBottom: { xs: "0px", lg: "25px" } } : {}
                        }}>
                          <MFCheckbox
                            name="isHeldAway"
                            label="Include Held Away in Overview page"
                            sx={(theme: Theme) => ({
                              display: 'flex',
                              alignItems: 'flex-start',
                              color: `${theme.palette.text.primary}`,
                              "& :disabled": {
                                color: `${theme.palette.text.secondary}`,
                              }
                            })}
                            disabled={loading || isDownloading || isNavbarInfoLoading || isInitiating}
                            onChange={({ target: { checked } }) => {
                              setValues({
                                ...values,
                                isHeldAway: checked,
                                isHeldAwayCalc: !checked ? false : values?.isHeldAwayCalc
                              })
                            }}
                          />
                        </Grid>
                      </Grid>
                    )}
                    {/* HeldAway Checkbox end */}

                    {/* Include Heldaway in calculations Checkbox start */}
                    {(`${values?.filterType ?? ""}`.toLowerCase() !== "portfolio") && (
                      <Grid
                        item
                        container
                        xs={12}
                        lg={6}
                        sx={{ alignItems: "center" }}
                      >
                        <Grid item>
                          <MFCheckbox
                            name="isHeldAwayCalc"
                            label="Include Held Away in calculations"
                            sx={(theme: Theme) => ({
                              display: 'flex',
                              alignItems: 'flex-start',
                              color: `${theme.palette.text.primary}`,
                              "& :disabled": {
                                color: `${theme.palette.text.secondary}`,
                              }
                            })}
                            disabled={
                              loading ||
                              isDownloading ||
                              isNavbarInfoLoading ||
                              isInitiating ||
                              !values?.isHeldAway
                            }
                          />
                        </Grid>
                      </Grid>
                    )}
                    {/* Include Heldaway in calculations Checkbox end */}

                  </Grid>
                  <Grid item container columnSpacing={3}>
                    <Grid item xs={8} />
                    <Grid item xs={4}>
                      {(
                        loading ||
                        isNavbarInfoLoading ||
                        isFamilyMembersDataLoading
                      ) && <Skeleton
                          animation={'wave'}
                          height={90}

                        />}
                      {(
                        !loading &&
                        !isNavbarInfoLoading &&
                        !isFamilyMembersDataLoading
                      ) && <MFSubmitButton
                          label="Initiate"
                          loadingEnable={isInitiating}
                          disabled={isDownloading}
                        />}
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )
          }}
        </Formik>
        <Divider
          sx={(theme: Theme) => ({
            mt: 4,
            mb: 4,
            borderColor: theme.palette.grey[500]
          })}
        />
        <Box sx={{ marginTop: 1 }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                columnGap: "10px"
              }}
            >
              <Box>
                <Typography
                  variant='h2'
                  sx={(theme: Theme) => ({
                    color: theme.palette.text.primary,
                    ...theme.typography.body_600,
                  })}
                >
                  Existing Client Statement
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "5px",
                    marginLeft: '-2px',
                    mt: 0.5
                  }}>
                  <InfoIconOutlined />
                  <Typography
                    variant='subtitle_600'
                    sx={(theme: Theme) => ({
                      color: theme.palette.grey[900]
                    })}
                  >
                    Statements will be available for 1 day only.
                  </Typography>
                </Box>
              </Box>
              <IconButton
                sx={{
                  cursor: 'pointer',
                  "&: disabled": {
                    opacity: 0.5
                  }
                }}
                onClick={handleRefresh}
                disabled={isTableDataLoading}
                aria-label="Refresh Client Statement Report"
              >
                <RefreshIcon />
              </IconButton>
            </Box>
            <Box sx={{ marginTop: 5 }}>
              <ClientStatementTable
                isLoading={isTableDataLoading}
                tableData={tableData}
                handleTableSort={handleTableSort}
                tablePaginationObj={tablePaginationObj}
                handleTableRowsPerPageChange={handleTableRowsPerPageChange}
                handleTablePageChange={handleTablePageChange}
                tableSortingObj={tableSortingObj}
                handleReportDownload={handleReportDownload}
                isDownloading={isDownloading}
                selectedJobIdForDownload={selectedJobIdForDownload}
              />
            </Box>
          </Box>
        </Box>
      </ReportsRightLayout>
      <Dialog
        onClose={handleNoInvestorDialogClose}
        open={isNoInvestorDialogVisible}
        maxWidth='sm'
        sx={(theme: Theme) => ({
          '& .MuiPaper-root': {
            borderRadius: '12px',
            backgroundColor: theme.palette.common.white,
            padding: "22px 24px",
            width: "533px",
          },
        })}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Box
              sx={{
                display: "flex",
                columnGap: "12px",
                alignItems: "center"
              }}
            >
              <YellowWarning />
              <Typography
                variant="h2"
                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
              >
                No Investor Found!!
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={handleNoInvestorDialogClose}
              sx={{
                padding: "5px"
              }}
            >
              <DialogCloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default ClientStatement;
